module.exports = "'data:image/svg+xml;utf8,<svg width=\"10\" height=\"11\" viewBox=\"0 0 10 11\" xmlns=\"http://www.w3.org/2000/svg\"><title>required</title><path d=\"M0 5.107L.566 3.35l3.516 1.152V.812h1.836V4.5L9.434 3.35 10 5.107 6.484 6.24l2.168 2.99-1.484 1.073L5 7.313l-2.168 2.99L1.348 9.23l2.168-2.99L0 5.107z\" fill=\"%238A93A3\" fill-rule=\"evenodd\"/></svg>'"


/*****************
 ** WEBPACK FOOTER
 ** ./src/Requirement/asterisk.svg
 ** module id = 212
 ** module chunks = 0
 **/